export default __webpack_public_path__ + "static/media/paul.4c356e6c.jpg";